import { Invoice, PaginationControls } from '@/lib/types';
import { List, Pagination } from 'antd';
import { FC } from 'react';
import { DossierRow } from './dossierRow';
import styles from './styles.module.scss';

interface DossiersListProps {
  isLoading: boolean;
  invoices: Invoice[];
  pagination: PaginationControls;
}

export const DossierList: FC<DossiersListProps> = ({
  isLoading,
  invoices,
  pagination,
}) => {
  return (
    <>
      <List<Invoice>
        className={styles.dossierList}
        grid={{ column: 1 }}
        loading={isLoading}
        dataSource={invoices}
        renderItem={(invoice) => (
          <List.Item key={invoice.invoiceId}>
            <DossierRow invoice={invoice} />
          </List.Item>
        )}
      />
      <Pagination
        current={pagination.page}
        pageSize={pagination.pageSize}
        onChange={pagination.onChange}
        total={pagination.total}
        size="small"
        showSizeChanger={false}
        hideOnSinglePage
        style={{ marginTop: 24, textAlign: 'left' }}
      />
    </>
  );
};
